import {
  SOCIAL_MEDIA_SELECT,
  SOCIAL_MEDIA_MOVE_UP,
  SOCIAL_MEDIA_MOVE_DOWN,
  SOCIAL_MEDIA_REMOVE,
  SOCIAL_MEDIA_SAVE,
  SOCIAL_MEDIA_CHANGE_COLOR,
  SOCIAL_MEDIA_CHANGE_HOVER_COLOR,
  SOCIAL_MEDIA_CHANGE_ICON_SIZE,
} from './action-names';

export function select(data) {
  return {
    type: SOCIAL_MEDIA_SELECT,
    ...data
  };
};

export function moveUp(data) {
  return {
    type: SOCIAL_MEDIA_MOVE_UP,
    ...data
  };
};

export function moveDown(data) {
  return {
    type: SOCIAL_MEDIA_MOVE_DOWN,
    ...data
  };
};

export function remove(data) {
  return {
    type: SOCIAL_MEDIA_REMOVE,
    ...data
  };
};

export function save(data) {
  return {
    type: SOCIAL_MEDIA_SAVE,
    ...data
  };
};

export function changeColor(data) {
  return {
    type: SOCIAL_MEDIA_CHANGE_COLOR,
    ...data
  };
};

export function changeHoverColor(data) {
  return {
    type: SOCIAL_MEDIA_CHANGE_HOVER_COLOR,
    ...data
  };
};

export function changeIconSize(data) {
  return {
    type: SOCIAL_MEDIA_CHANGE_ICON_SIZE,
    ...data
  };
};



// WEBPACK FOOTER //
// ./app/header-builder/actions/social-media-element-actions.js